"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAvatar = getMuiAvatar;
function getMuiAvatar(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        backgroundColor: palette.primary.main,
        color: palette.common.white,
        fontSize: 24,
        fontWeight: 400
      }
    }
  };
}